// extracted by mini-css-extract-plugin
export default {"wrapper":"wN","header":"xN","headerwrap":"yN","title":"zN","icon":"AN","textwrap":"BN"};
    if(module.hot) {
      // 1714422956859
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  